import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Nav } from 'reactstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';

import User from '../Asset/app/media/img/users/user.png';
import NexdmImg from '../Asset/app/media/img//logos/nexdigm-logo.png';
import './NavMenu.css';
import axios from 'axios';
import global from './global';

export class SideBar extends Component {
    static displayName = SideBar.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            role: '',
            token: '',
            url: ''
        };
        this.state.role = localStorage.getItem('role');
        this.state.token = localStorage.getItem('token');
        this.state.url = localStorage.getItem('remitterCode');
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }


    render() {
        return (

            <div className="m-grid__item	m-aside-left  m-aside-left--skin-dark ">
                <button className="m-aside-left-close  m-aside-left-close--skin-dark " id="m_aside_left_close_btn">
                    <i className="la la-close"></i>
                </button>
                <div id="m_aside_left" className="m-grid__item	m-aside-left  m-aside-left--skin-dark ">
                    <div id="m_ver_menu" className="m-aside-menu  m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark " m-menu-vertical="1" m-menu-scrollable="0" m-menu-dropdown-timeout="500">
                        <ul className="m-menu__nav  m-menu__nav--dropdown-submenu-arrow ">
                            <li className="m-menu__item  m-menu__item--active" aria-haspopup="true" >
                                <a href="dashboard.html" className="m-menu__link ">
                                    <i className="m-menu__link-icon fa fa-home"></i>
                                    <span className="m-menu__link-title">
                                        <span className="m-menu__link-wrap">
                                            <span cclassNamelass="m-menu__link-text">
                                                Easy Dividend
											</span>
                                        </span>
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        );
    }
}
